module.exports = __webpack_public_path__ + "static/img/Verfication Code.3fbda9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Verfication Code.png
// module id = 221
// module chunks = 7